exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".device-list .nav-link span{text-overflow:ellipsis;overflow:hidden;white-space:nowrap}.device-list .nav-link i{line-height:1.5}.device-list .nav-link.active{border-radius:0}", ""]);

// exports
